import { useEffect, useState } from "react";
import { Link, useNavigate, useHref } from "react-router-dom";

import { styled } from '@mui/material/styles';
import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Rating from '@mui/material/Rating';
import Typography from '@mui/material/Typography';
import Switch from '@mui/material/Switch';
import Container from '@mui/material/Container';
import Alert from '@mui/material/Alert';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import CircularProgress from '@mui/material/CircularProgress';
import useMediaQuery from '@mui/material/useMediaQuery';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';

import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';

import * as React from 'react';
import Collapse from '@mui/material/Collapse';
import Avatar from '@mui/material/Avatar';
import { red } from '@mui/material/colors';
import FavoriteIcon from '@mui/icons-material/Favorite';
import ShareIcon from '@mui/icons-material/Share';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AddBoxTwoToneIcon from '@mui/icons-material/AddBoxTwoTone';

import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';
import DeleteTwoToneIcon from '@mui/icons-material/DeleteTwoTone';
import ZoomInTwoToneIcon from '@mui/icons-material/ZoomInTwoTone';

const config = require("./../../constants/constants.js")

const ExpandMore = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme }) => ({
  marginLeft: 'auto',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
  variants: [
    {
      props: ({ expand }) => !expand,
      style: {
        transform: 'rotate(0deg)',
      },
    },
    {
      props: ({ expand }) => !!expand,
      style: {
        transform: 'rotate(180deg)',
      },
    },
  ],
}));


const AppointmentCardComponent = ({ appointmentItem, idx, setShowDetailAppointmentNumber, setShowInfoEventSection, setShowDeleteEventSection, setShowDisplayEventSection, setOpenDialogDeleteAppointment,
  dailyAppointments, setHourStartBooking, setHourStartBookingString, setHourEndBooking, setHourEndBookingString, setDurataScelta, setCategory, setEvent, setProdottoScelto, setTitleAppointment, setDescriptionAppointment, setNoteAppointment,
  setClienteDigitato, setRisorsaScelta, setSitoScelto, getEventsApiRequest, setEventsList, setShowDailyEventsSection, setImages
}) => {


  // setShowDisplayEventSection   VEDI
  // setShowInfoEventSection      MODIFICA
  // setShowDeleteEventSection    DELETE

  let navigate = useNavigate();

  const widthCard = 390;

  const [expanded, setExpanded] = React.useState(false);
  const [start, setStart] = React.useState({});
  const [end, setEnd] = React.useState({});


  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  console.log("[AppointmentCardComponent] appointmentItem =", appointmentItem);
  console.log("[AppointmentCardComponent] idx =", idx);
  console.log("[AppointmentCardComponent] appointmentItem.name =", appointmentItem.name);
  console.log("[AppointmentCardComponent] start =", appointmentItem.start);

  useEffect(() => {
    if (!appointmentItem || !appointmentItem.start) {
      setStart('00:00');
    }
    else setStart(appointmentItem.start);
    console.log("[CreateEventElementCard useEffect] appointmentItem.start=", appointmentItem.start)
    if (!appointmentItem || !appointmentItem.end) {
      setEnd('00:00');
    }
    else setEnd(appointmentItem.end);
    console.log("[CreateEventElementCard useEffect] appointmentItem.end=", appointmentItem.end)
    //console.log("[CreateEventElementCard useEffect] appointmentItem.start=",appointmentItem.start.hourString)
    //console.log("[CreateEventElementCard useEffect] pageAll=",subTitleImage)
  }, [setStart, setEnd])


  const handleCancellaAppuntamento = (appointmentItem, idx) => {
    console.log('[handleCancellaAppuntamento] idx =', idx);
    console.log('[handleCancellaAppuntamento] appointmentItem =', appointmentItem);
    console.log('[handleCancellaAppuntamento] appointmentItem.durationMins =', appointmentItem.durationMins);
    console.log('[handleCancellaAppuntamento] appointmentItem.category =', appointmentItem.eventtype);
    console.log('[handleCancellaAppuntamento] appointmentItem.event =', appointmentItem.event);
    console.log('[handleCancellaAppuntamento] appointmentItem.customer =', appointmentItem.customer);

    setShowDetailAppointmentNumber(idx);
    setHourStartBookingString(appointmentItem.start.hourString)
    setOpenDialogDeleteAppointment(true);

    setShowDisplayEventSection("No");
    setShowInfoEventSection("No");

    setShowDeleteEventSection("Si");
  }


  const handleModificaAppuntamento = (appointmentItem, idx) => {
    console.log('[handleModificaAppuntamento in Card] idx =', idx);
    console.log('[handleModificaAppuntamento] appointmentItem =', appointmentItem);
    console.log('[handleModificaAppuntamento] appointmentItem.durationMins =', appointmentItem.durationMins);
    console.log('[handleModificaAppuntamento] appointmentItem.category =', appointmentItem.eventtype);
    console.log('[handleModificaAppuntamento] appointmentItem.event =', appointmentItem.event);
    console.log('[handleModificaAppuntamento] appointmentItem.customer =', appointmentItem.customer);
    console.log('[handleModificaAppuntamento] appointmentItem.images =', appointmentItem.images);

    // aggiorno var per Panel dettagli app.
    //setHourStartBooking(appointmentItem.start.hourString);
    setHourStartBookingString(appointmentItem.start.hourString);
    //setName(appointmentItem.name);
    setDurataScelta(appointmentItem.durationMins);
    setCategory(appointmentItem.eventtype);
    setEvent(appointmentItem.event);
    setProdottoScelto(appointmentItem.event);
    setTitleAppointment(appointmentItem.name);
    setDescriptionAppointment(appointmentItem.description)
    setNoteAppointment(appointmentItem.note);
    setClienteDigitato(appointmentItem.customer);
    setRisorsaScelta(appointmentItem.resource);
    setSitoScelto(appointmentItem.site);
    setImages(appointmentItem.images);

    // set oraInizio, oraFine

    console.log('[handleModificaAppuntamento] appointmentItem.start.hourString =', appointmentItem.start.hourString);
    console.log('[handleModificaAppuntamento] appointmentItem.start.hour =', appointmentItem.start.hour);
    console.log('[handleModificaAppuntamento] appointmentItem.end.hourString =', appointmentItem.end.hourString);
    console.log('[handleModificaAppuntamento] appointmentItem.customer =', appointmentItem.end.hour);

    setHourStartBookingString(appointmentItem.start.hourString);
    setHourStartBooking(appointmentItem.start.hour);
 
    setHourEndBookingString(appointmentItem.end.hourString);
    setHourEndBooking(appointmentItem.end.hour);

    getEventsApiRequest(appointmentItem.eventtype, "", "", "", "")
      .then((productItems) => {
        setEventsList(productItems.events);
        console.log('combo =', appointmentItem.eventtype);
        //console.log('categoriaScelta=',categoriaScelta); 
        console.log('productItems=', productItems);
      })
      .catch((er) => {
        console.log(er);
      });

    setShowDisplayEventSection("No");
    setShowDeleteEventSection("No");

    setShowDetailAppointmentNumber(idx);
    setShowInfoEventSection("Si");

    setShowDailyEventsSection("No");
  }

  const handleVediAppuntamento = (appointmentItem, idx) => {
    console.log('[handleVediAppuntamento] idx =', idx);
    console.log('[handleVediAppuntamento] appointmentItem =', appointmentItem);
    console.log('[handleVediAppuntamento] appointmentItem.durationMins =', appointmentItem.durationMins);
    console.log('[handleVediAppuntamento] appointmentItem.category =', appointmentItem.eventtype);
    console.log('[handleVediAppuntamento] appointmentItem.event =', appointmentItem.event);
    console.log('[handleVediAppuntamento] appointmentItem.customer =', appointmentItem.customer);

    // aggiorno var per Panel dettagli app.
    //setHourStartBooking(appointmentItem.start.hourString);
    setHourStartBookingString(appointmentItem.start.hourString);
    //setName(appointmentItem.name);
    setDurataScelta(appointmentItem.durationMins);
    setCategory(appointmentItem.eventtype);
    setEvent(appointmentItem.event);
    setProdottoScelto(appointmentItem.event);
    setTitleAppointment(appointmentItem.name);
    setDescriptionAppointment(appointmentItem.description)
    setNoteAppointment(appointmentItem.note);
    setClienteDigitato(appointmentItem.customer);
    setRisorsaScelta(appointmentItem.resource);
    setSitoScelto(appointmentItem.site);

    // set oraInizio, oraFine

    console.log('[handleVediAppuntamento] appointmentItem.start.hourString =', appointmentItem.start.hourString);
    console.log('[handleVediAppuntamento] appointmentItem.start.hour =', appointmentItem.start.hour);
    console.log('[handleVediAppuntamento] appointmentItem.end.hourString =', appointmentItem.end.hourString);
    console.log('[handleVediAppuntamento] appointmentItem.customer =', appointmentItem.end.hour);

    setHourStartBookingString(appointmentItem.start.hourString);
    setHourStartBooking(appointmentItem.start.hour);
 
    setHourEndBookingString(appointmentItem.end.hourString);
    setHourEndBooking(appointmentItem.end.hour);

    getEventsApiRequest(appointmentItem.eventtype, "", "", "", "")
      .then((productItems) => {
        setEventsList(productItems.events);
        console.log('combo =', appointmentItem.eventtype);
        //console.log('categoriaScelta=',categoriaScelta); 
        console.log('productItems=', productItems);
      })
      .catch((er) => {
        console.log(er);
      });
    /*
           "name": titleAppointment,
           "description": descriptionAppointment,
           "note": noteAppointment,
           "event": prodottoScelto,
           "eventtype": categoriaScelta,
           "resource": risorsaScelta,
           "site": sitoScelto,
           "durationMins": durataScelta,
           "customer": clienteDigitato,
           "start": startDate,
           "end": endDate,
    */

    setShowDeleteEventSection("No");
    setShowInfoEventSection("No");

    setShowDetailAppointmentNumber(idx);
    setShowDisplayEventSection("Si");

    setShowDailyEventsSection("No");
  };

  return (

    <Card
      sx={{
        //width: widthCard + 30,
        minWidth: widthCard + 30,
        borderColor: '#0c2b85',
        //border: 0,
        //margin: 0,
        paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
        backgroundColor: '#ffffff',
        '&:hover': {
          backgroundColor: '#e9e9e9',
          opacity: [0.9, 0.8, 0.7],
        },
      }}
    >

      <CardContent
        sx={{
          paddingTop: 1, paddingBottom: 0, paddingLeft: 1, paddingRight: 1,
          width: widthCard,
        }}
      >

        <Box
          sx={{
            width: widthCard + 20,
            maxHeight: { xs: widthCard, md: widthCard },
          }}
        >

          <Grid container
            spacing={0}
            sx={{
              paddingLeft: 0, paddingRight: 0, paddingTop: 0, paddingBottom: 0,
              flexDirection: { xs: "row", md: "row" }
            }}
            onClick={() => {
              handleVediAppuntamento(appointmentItem, idx)
            }}
          >

            <Grid size={{ xs: 6, md: 6 }}>

              <Stack direction="row" gap={0.5}>
                <Typography
                  sx={{
                    fontFamily: 'Arial',
                    fontWeight: 500,
                    fontSize: 12,
                    color: 'rgb(24, 24, 175)',
                  }}
                >
                  ora inizio
                </Typography>
                <Typography
                  sx={{
                    fontFamily: 'Arial',
                    fontWeight: 500,
                    fontSize: 12,
                    color: 'rgb(24, 24, 175)',
                    background: 'rgb(191, 237, 225)',
                    fontWeight: 'fontWeightBold'
                  }}
                >
                  {start.hourString}
                </Typography>
              </Stack>

              <Stack direction="row" gap={0.5}>
                <Typography
                  sx={{
                    fontFamily: 'Arial',
                    fontWeight: 500,
                    fontSize: 12,
                    color: 'rgb(24, 24, 175)'
                  }}
                >
                  titolo
                </Typography>
                <Typography
                  sx={{
                    fontFamily: 'Arial',
                    fontWeight: 500,
                    fontSize: 12,
                    color: 'rgb(24, 24, 175)',
                    fontWeight: 'fontWeightBold'
                  }}
                >
                  {appointmentItem.name}
                </Typography>
              </Stack>

              <Stack direction="row" gap={0.5}>
                <Typography
                  sx={{
                    fontFamily: 'Arial',
                    fontWeight: 500,
                    fontSize: 12,
                    color: 'rgb(24, 24, 175)'
                  }}
                >
                  tipo evento
                </Typography>
                <Typography
                  sx={{
                    fontFamily: 'Arial',
                    fontWeight: 500,
                    fontSize: 12,
                    color: 'rgb(24, 24, 175)',
                    fontWeight: 'fontWeightBold'
                  }}
                >
                  {appointmentItem.eventtype}
                </Typography>
              </Stack>

              <Stack direction="row" gap={0.5}>
                <Typography
                  sx={{
                    fontFamily: 'Arial',
                    fontWeight: 500,
                    fontSize: 12,
                    color: 'rgb(24, 24, 175)'
                  }}
                >
                  cliente
                </Typography>
                <Typography
                  sx={{
                    fontFamily: 'Arial',
                    fontWeight: 500,
                    fontSize: 12,
                    color: 'rgb(24, 24, 175)',
                    fontWeight: 'fontWeightBold'
                  }}
                >
                  {appointmentItem.customer}
                </Typography>
              </Stack>

              <Stack direction="row" gap={0.5}>
                <Typography
                  sx={{
                    fontFamily: 'Arial',
                    fontWeight: 500,
                    fontSize: 12,
                    color: 'rgb(24, 24, 175)'
                  }}
                >
                  risorsa
                </Typography>
                <Typography
                  sx={{
                    fontFamily: 'Arial',
                    fontWeight: 500,
                    fontSize: 12,
                    color: 'rgb(24, 24, 175)',
                    fontWeight: 'fontWeightBold'
                  }}
                >
                  {appointmentItem.resource}
                </Typography>

              </Stack>

              {/* 
              <Stack direction="row" gap={0.5}>
                <Typography
                  sx={{
                    fontFamily: 'Arial',
                    fontWeight: 500,
                    fontSize: 12,
                    color: 'rgb(24, 24, 175)'
                  }}
                >
                  minuti
                </Typography>
                <Typography
                  sx={{
                    fontFamily: 'Arial',
                    fontWeight: 500,
                    fontSize: 12,
                    color: 'rgb(24, 24, 175)',
                    fontWeight: 'fontWeightBold'
                  }}
                >
                  {appointmentItem.durationMins}
                </Typography>
              </Stack>
            */}

            </Grid>

            <Grid size={{ xs: 6, md: 6 }}>

              <Stack direction="row" gap={0.5}>
                <Typography
                  sx={{
                    fontFamily: 'Arial',
                    fontWeight: 500,
                    fontSize: 12,
                    color: 'rgb(24, 24, 175)',
                  }}
                >
                  ora fine
                </Typography>
                <Typography
                  sx={{
                    fontFamily: 'Arial',
                    fontWeight: 500,
                    fontSize: 12,
                    color: 'rgb(24, 24, 175)',
                    background: 'rgb(191, 237, 225)',
                    fontWeight: 'fontWeightBold'
                  }}
                >
                  {end.hourString}
                </Typography>
              </Stack>

              <Stack direction="row" gap={0.5}>
                <Typography
                  sx={{
                    fontFamily: 'Arial',
                    fontWeight: 200,
                    fontSize: 12,
                    color: 'rgb(24, 24, 175)'
                  }}
                >
                  descrizione
                </Typography>
                <Typography
                  sx={{
                    fontFamily: 'Arial',
                    fontWeight: 200,
                    fontSize: 12,
                    color: 'rgb(24, 24, 175)',
                    fontWeight: 'fontWeightBold'
                  }}
                >
                  {appointmentItem.description}
                </Typography>
              </Stack>

              <Stack direction="row" gap={0.5}>
                <Typography
                  sx={{
                    fontFamily: 'Arial',
                    fontWeight: 200,
                    fontSize: 12,
                    color: 'rgb(24, 24, 175)'
                  }}
                >
                  evento
                </Typography>
                <Typography
                  sx={{
                    fontFamily: 'Arial',
                    fontWeight: 200,
                    fontSize: 12,
                    color: 'rgb(24, 24, 175)',
                    fontWeight: 'fontWeightBold'
                  }}
                >
                  {appointmentItem.event}
                </Typography>
              </Stack>

              <Stack direction="row" gap={0.5}>
                <Typography
                  sx={{
                    fontFamily: 'Arial',
                    fontWeight: 200,
                    fontSize: 12,
                    color: 'rgb(24, 24, 175)'
                  }}
                >
                  note
                </Typography>
                <Typography
                  sx={{
                    fontFamily: 'Arial',
                    fontWeight: 200,
                    fontSize: 12,
                    color: 'rgb(24, 24, 175)',
                    fontWeight: 'fontWeightBold'
                  }}
                >
                  {appointmentItem.note}
                </Typography>
              </Stack>

              <Stack direction="row" gap={0.5}>
                <Typography
                  sx={{
                    fontFamily: 'Arial',
                    fontWeight: 500,
                    fontSize: 12,
                    color: 'rgb(24, 24, 175)'
                  }}
                >
                  luogo
                </Typography>
                <Typography
                  sx={{
                    fontFamily: 'Arial',
                    fontWeight: 500,
                    fontSize: 12,
                    color: 'rgb(24, 24, 175)',
                    fontWeight: 'fontWeightBold'
                  }}
                >
                  {appointmentItem.site}
                </Typography>
              </Stack>

            </Grid>

          </Grid>

          <Grid
            container
            //padding={0}
            //spacing={0}
            justifyContent={"flex-end"}
            sx={{
              //paddingLeft: 0, paddingRight: 0, paddingTop: 0, paddingBottom: 0,
              //flexDirection: { xs: "row", md: "row" }
            }}
          >

            <Tooltip title="dettagli" arrow placement="bottom">
              <IconButton
                size="small"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={() => {
                  handleVediAppuntamento(appointmentItem, idx)
                }}
                color="inherit"
              >
                <ZoomInTwoToneIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="modifica" arrow placement="bottom">
              <IconButton
                size="small"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={() => {
                  handleModificaAppuntamento(appointmentItem, idx)
                }}
                color="inherit"
              >
                <EditTwoToneIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="cancella" arrow placement="bottom">
              <IconButton
                size="small"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={() => {
                  handleCancellaAppuntamento(appointmentItem, idx)
                }}
                color="inherit"
              >
                <DeleteTwoToneIcon />
              </IconButton>
            </Tooltip>
          </Grid>

        </Box>

      </CardContent>

    </Card>

  );
};

export default AppointmentCardComponent;
